import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AsciiFileCurrencyOptionEnum, asciiFileCurrencyOptionsList } from '~modules/connectors/modules/load/common/ascii-file-currency-options';
import { BasicLoadConfigurationOptionsComponent } from '~modules/connectors/modules/load/common/components/basic-configuration-options/basic-load-configuration-options.component';
import { DocumentOptionEnum, DocumentOptionType, DocumentService } from '~modules/connectors/modules/load/common/services/document-option.service';
import { AsciiDownloadFieldsConfiguration } from '~modules/connectors/services/extract-connectors-configurations/field-type';

@Component({
  selector: 'app-load-zip-ascii-download-configuration',
  templateUrl: './load-zip-ascii-download-configuration.component.html',
  styleUrls: ['./load-zip-ascii-download-configuration.component.scss'],
  standalone: true,
  providers: [
    DocumentService
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,

    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatButtonModule,
    MatRadioModule,
    MatTooltipModule,
    MatSlideToggleModule,
    BasicLoadConfigurationOptionsComponent
  ]
})
export class LoadZipAsciiDownloadConfigurationComponent {
  formGroup!: FormGroup;
  configuration?: AsciiDownloadFieldsConfiguration;
  fileCurrencyOptions = asciiFileCurrencyOptionsList;
  documentOptions: DocumentOptionType[];
  configurationMode: string | undefined;
  fileCurrencyTooltipText = `- EUR : "Pour les comptabilités en Euros"
  - FRF : "Pour les comptabilités en Franc Pacifique / Franc CPF / XPF"`;

  @Input()
  set configMode(configMode: string | undefined) {
    this.configurationMode = configMode;
  }


  @Input()
  set config (config: AsciiDownloadFieldsConfiguration | null) {
    if (config != null) {
      this.configuration = config;
      this.formGroup.get('fileCurrency')?.setValue(config.fileCurrency.defaultValue);
      this.formGroup.get('documentOption')?.setValue(config.documentOption.defaultValue);
      this.formGroup.get('entryLabelCodeMapping')?.setValue(config.entryLabelCodeMapping.defaultValue);
    }
  }

  constructor(
    private readonly fb: FormBuilder,
    readonly documentService: DocumentService
  ) {
    this.documentOptions = documentService.getAll();
    this.formGroup = fb.group({
      fileCurrency: [AsciiFileCurrencyOptionEnum.EUR, Validators.required],
      documentOption: [DocumentOptionEnum.ALL_LINES],
      entryLabelCodeMapping: [false]
    });
  }
}
